import {Product} from "~/utils/Product";
import {Category} from "~/utils/Category";
import {useModyApi} from "~/middelware/ModyApi";
import {host} from "~/utils/constants";
import { useUserDataStorage } from "~/store/userdata";
import Toast from "primevue/toast";
import type { ToastServiceMethods } from "primevue/toastservice";

export class Cart {
    products: CartProduct[] = []
    
    async addProduct(count:number,product:Product){
        //Check if product already in cart
        let factor = 1.0;
        let comment = ""
        let productInCart = -1
        let sectionName = ""
        this.products.forEach((tempProduct,index)=>{
            if(tempProduct.product.id == product.id){
                productInCart = index
            }
        })
        if(productInCart>=0){ //Product is already in cart, so count up
            this.products[productInCart].count += count
        }
        else{//Not already in cart, so add it
            this.products.push({
                editSectionName: false, count, product, factor,
                price: product.Price, comment, sectionName
            })
        }
        await useModyApi().updateCart(this)
    }
    async removeProduct(product:Product){
        let productInCart = -1
        this.products.forEach((tempProduct,index)=>{
            if(tempProduct.product.id == product.id){
                productInCart = index
            }
        })
        if(productInCart>=0){ //Product is already in cart, so count up
            this.products.splice(productInCart,1)
        }
        await useModyApi().updateCart(this)
    }
    parseJSON(ret:ApiCart[]){
        this.products = []
        ret.forEach((retProduct)=>{
            const tempProduct = new Product()
            tempProduct.id = retProduct.product.id
            tempProduct.Name = retProduct.product.Name
            tempProduct.Price = retProduct.product.Price
            tempProduct.showPrice = retProduct.product.showPrice
            retProduct.product.Images.forEach((image) => {
                tempProduct.Images.push(host + image.url);
            });
            this.products.push({
                count:retProduct.Anzahl,
                product:tempProduct,
                comment: retProduct.comment,
                factor: retProduct.factor,
                price: retProduct.price ? retProduct.price : tempProduct.Price,
                editSectionName: false,
                sectionName: retProduct.sectionName
            })
        })
    }
    toJSON() {
       return cartToJson(this)
    }
    toApiStruct(){
        const retValue:{Anzahl:number,factor:number,price:number,comment:string, product:{id:number}}[] = []
        this.products.forEach((product)=>{
            retValue.push({Anzahl:product.count,factor:product.factor,price:product.price,comment:product.comment, product:{id:product.product.id}})
        })
        return retValue
    }
}

export async function updateCart(cart:Cart){
    await useModyApi().updateCart(cart)
}
export function cartToJson(cart:Cart){
    const retValue = {...cart}
    const optimizedProducts:CartProduct[] = []
    retValue.products.forEach((product)=>{
        optimizedProducts.push(<CartProduct>{
            "count": product.count,
            "product": {
                "id": product.product.id,
                "Name": product.product.Name,
                "Price": product.product.Price,
                "Images": product.product.Images,
                "showPrice": product.product.showPrice
            },
            "factor": product.factor,
            "price": product.price,
            "comment": product.comment,
        })
    })
    retValue.products = optimizedProducts as {count:number, product:Product, factor:number, price:number, comment:string, sectionName:string}[]
    return retValue // here I make a POJO's copy of the class instance
}
export async function addToCart(count: number, product: Product, toast:ToastServiceMethods){
    const userStore = useUserDataStorage()
    const api = useModyApi()
    if(userStore.loggedIn){
        const cart = await api.getUserCart()
        try {
            await cart.addProduct(count,product)
        } catch (error) {}
    }
    else{
        if(!userStore.browserCart?.addProduct){
            const tempProducts:CartProduct[] = userStore.browserCart ? userStore.browserCart?.products:[]
            userStore.browserCart = new Cart()
            userStore.browserCart.products = tempProducts
        }
        userStore.browserCart.addProduct(count,product)
    }
    toast.add({severity:"success",detail:"Hinzugefügt",life:3000})
}

export async function removeFromCart(product:Product){
    const userStore = useUserDataStorage()
    const api = useModyApi()
    if(userStore.loggedIn){
        const cart = await api.getUserCart()
        try {
            await cart.removeProduct(product)
        } catch (error) {}
    }
    else{
        if(!userStore.browserCart?.removeProduct){
            const tempProducts:CartProduct[] = userStore.browserCart ? userStore.browserCart?.products:[]
            userStore.browserCart = new Cart()
            userStore.browserCart.products = tempProducts
        }
        userStore.browserCart.removeProduct(product)
    }
}

export function getDayFactor(n:number){
    // Direkte Rückgabe für die ersten beiden Sonderfälle
    const step1 = 5
    const step2 = 11
    let faktor = 1
    
    if(n == 1) return faktor
    else if (n <= step1) {
        faktor += (n - 1) * 0.5;
    } 
    else if (n <= step2) {
        faktor = getDayFactor(step1) //Faktor bei 3
        faktor += (n - step1) * 0.4;
    }
    else {
        faktor = getDayFactor(step2) //Faktor bei 6
        faktor += (n - step2) * 0.3;
    }
    
    // Rundet das Ergebnis auf eine Dezimalstelle, um Gleitkommafehler zu vermeiden
    return Math.round(faktor * 10) / 10;
}

interface ApiCart{
    id:number,
    Anzahl:number,
    factor:number,
    price:number,
    comment:string,
    sectionName:string,
    product: {
        id:number,
        Name:string, 
        Price:number,
        Images:any[],
        showPrice: "admin"|"customer"|"public"
    }
}
export class CartProduct{
    count:number
    product:Product
    factor:number
    price:number
    sectionName:string
    comment:string
    editSectionName = false
    
    constructor(count:number, product:Product, factor:number, price:number, sectionName:string,comment:string,) {
        this.count = count
        this.product = product
        this.factor = factor
        this.sectionName = sectionName
        this.comment = comment
        this.price = price
    }
}